import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { selectIsZeroValueOrder, useSelector } from "@jti/store";
import { Button, useFormContext, useTranslations } from "@jti/ui";
import { useFreeTrial } from "../../../../hooks";
import useDelivery from "../../../../hooks/useDelivery";
import { useGetProfile } from "../../../../hooks/useGetProfile";
import styles from "./DeliveryFormFooter.module.scss";
export const DeliveryFormFooter = ({ isSubmitDisabled, onSubmitButtonClick, className, ...restProps }) => {
    const { __ } = useTranslations();
    const { shippingMethods, setShippingMethodsOnCartPending, placingOrder, priceFetchStatus } = useDelivery();
    const { isLoading: isGetProfileLoading } = useGetProfile();
    const { isFreeTrial } = useFreeTrial();
    const isZeroValueOrder = useSelector(selectIsZeroValueOrder(isFreeTrial));
    const formContext = useFormContext();
    const { isSubmitting } = formContext.formState;
    const isSubmitButtonPending = isSubmitting ||
        placingOrder ||
        priceFetchStatus === "pending" ||
        shippingMethods.fetchStatus === "pending" ||
        isGetProfileLoading ||
        setShippingMethodsOnCartPending;
    return (_jsxs("div", { className: classnames([styles.wrapper, className]), ...restProps, children: [_jsx(Button, { className: styles.button, color: "primary", isPending: isSubmitButtonPending, disabled: isSubmitDisabled, type: "submit", onClick: onSubmitButtonClick, children: isZeroValueOrder ? __("cart.order.payment.finalize") : __("cart.checkout.place_order.button") }), _jsxs("div", { className: styles.text, "data-testid": "place-order-warning-text", children: [__("cart.checkout.place_order.text"), _jsx("span", { className: styles.notText, children: ` ${__("cart.checkout.place_order.text.not")} ` }), __("cart.checkout.place_order.text_next"), _jsx("div", { className: styles.subText, children: __("cart.checkout.place_order.sub_text") })] })] }));
};
//# sourceMappingURL=DeliveryFormFooter.js.map